import React, { useEffect } from "react";
import { Grid2, Typography, Card, Button } from "@mui/material";
import { Link } from "react-router-dom";

const CoachingSignUpComplete = () => {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = "/clients";
    }, 3000);
  }, []);
  return (
    <Grid2 container justifyContent="center">
      <Grid2 item lg={6} sm={12}>
        <Card sx={{ p: 3, mt: 4 }}>
          <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
            Account Created Successfully!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Redirecting to dashboard...
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to="/clients"
            sx={{ mt: 2, display: "block", mx: "auto" }}
          >
            Go to Dashboard
          </Button>
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default CoachingSignUpComplete;
